import { render } from "./IssueNoRequest.vue?vue&type=template&id=52206bc9&scoped=true"
import script from "./IssueNoRequest.vue?vue&type=script&lang=js"
export * from "./IssueNoRequest.vue?vue&type=script&lang=js"

import "./IssueNoRequest.vue?vue&type=style&index=0&id=52206bc9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52206bc9"]])

export default __exports__